import {nanoid} from 'nanoid';
import {WatchlistDefinition} from './watchlist-definitnion';
import {WatchlistId} from './watchlist-id';

export function getNewWatchlistId(): WatchlistId {
    return nanoid();
}

export interface Watchlist extends WatchlistDefinition {
    isReadonly?: boolean;
}
